import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userCheck"
const UserCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm5.883 11.289C15.42 13.496 13.327 13 11 13c-4.42 0-8 1.79-8 4v2h7.172l-.586-.586a2 2 0 0 1 0-2.828l1.5-1.5a2 2 0 0 1 2.828 0l1.586 1.586 1.383-1.383Zm5.617.211L21 13l-5.5 5.5-3-3L11 17l4.5 4.5 7-7Z"
          />
        </svg>
      }
    </span>
  )
}
export default UserCheckIcon
